export const convertToFormData = (
  object: Record<string, unknown>,
  form: FormData = new FormData(),
  namespace?: string,
): FormData => {
  for (const key of Object.keys(object)) {
    const value = object[key];
    if (value === null || value === undefined || value === '') {
      continue;
    }

    const formKey = namespace ? `${namespace}[${key}]` : key;

    if (value instanceof Date) {
      form.append(formKey, value.toISOString());
    } else if (Array.isArray(value)) {
      if (value.length === 0) {
        form.append(formKey, '[]');
      } else {
        value.forEach((item, index) => {
          const arrayKey = `${formKey}[${index}]`;
          if (item instanceof Date) {
            form.append(arrayKey, item.toISOString());
          } else if (typeof item === 'object' && item !== null) {
            convertToFormData(item as Record<string, unknown>, form, arrayKey);
          } else {
            form.append(arrayKey, String(item));
          }
        });
      }
    } else if (typeof value === 'object') {
      convertToFormData(value as Record<string, unknown>, form, formKey);
    } else {
      form.append(formKey, String(value));
    }
  }

  return form;
};
